import userApi from '../api/UserApi';
import userStore from '../shared/UserStore';
import { getUserManager } from '../shared/userManager';
import * as types from './actionTypes';
import { loadLanguage } from './languageActions';
import { loadContent } from './contentActions';
import ImperpnationStore from '../shared/ImpersonationStore';
import _ from 'lodash';

export function loginSuccess(user: any) {
    return { type: types.LOGIN_SUCCESS, user };
}

export function renewUserSession(user: any) {
    return { type: types.RENEW_USER_SESSION, user };
}

export function loginFailed(message: string) {
    return { type: types.LOGIN_FAILED, message };
}

export function logoutSuccess() {
    return { type: types.LOGOUT_SUCCESS };
}

export function impersonateSuccess(user: any) {
    return { type: types.IMPERSONATE_SUCCESS, user };
}

export function unimpersonateSuccess(user: any) {
    return { type: types.UNIMPERSONATE_SUCCESS, user };
}

export function impersonateCountrySuccess(country: any) {
    return { type: types.IMPERSONATE_COUNTRY_SUCCESS, country };
}

export function unImpersonateCountrySuccess() {
    return { type: types.UNIMPERSONATE_COUNTRY_SUCCESS };
}

export function impersonate(userid: number): (dispatch: any) => Promise<any> {
    return (dispatch: any): Promise<any> => {
        ImperpnationStore.setUserImpersonationId(userid);
        unImpersonateCountry();
        return userApi
            .getMeDetails()
            .then(
                (result: {
                    features: string[];
                    languageKey: string;
                    name: string;
                    id: number;
                    applicationVersion: string;
                }) => {
                    let user = userStore.fetchUserFromLocalStorage();
                    user.details = { ...result };
                    userStore.saveUserToLocalStorage(user);
                    dispatch(loadContent());
                    dispatch(impersonateSuccess(user));
                }
            );
    };
}

export function unimpersonate(): (dispatch: any) => Promise<any> {
    return (dispatch: any): Promise<any> => {
        ImperpnationStore.clearUserImpersonationId();
        return userApi
            .getMeDetails()
            .then(
                (result: {
                    features: string[];
                    languageKey: string;
                    name: string;
                    id: number;
                    applicationVersion: string;
                    role: string;
                    impersonatedUsername: string;
                    isImpersonated: boolean;
                    isCustomer: boolean;
                    canManageTranslations: boolean;
                }) => {
                    const storageUser = userStore.fetchUserFromLocalStorage();
                    let user = _.merge({}, storageUser);
                    user.details.features = result.features;
                    user.details.name = result.name;
                    user.details.id = result.id;
                    user.details.applicationVersion = result.applicationVersion;
                    user.details.role = result.role;
                    user.details.impersonatedUsername = result.impersonatedUsername;
                    user.details.isCustomer = result.isCustomer;
                    user.details.isImpersonated = result.isImpersonated;
                    user.details.canManageTranslations = result.canManageTranslations;

                    dispatch(loadContent());
                    dispatch(unimpersonateSuccess(user));

                    userStore.saveUserToLocalStorage(user);
                }
            );
    };
}

function translationsVersionOf(details: { translationsVersion?: number }): string {
    return details.translationsVersion === undefined ? null : String(details.translationsVersion);
}

export function loadUserFromLocalStorage(contentLoaded?: boolean) {
    return (dispatch: any) => {
        const user = userStore.fetchUserFromLocalStorage();
        if (user) {
            if (!contentLoaded) {
                dispatch(loadContent());
            }
            dispatch(
                loadLanguage(
                    user.details.languageKey,
                    user.details.applicationVersion,
                    translationsVersionOf(user.details)
                )
            );
            dispatch(loginSuccess(user));
        }
    };
}

export function impersonateCountry(country) {
    return (dispatch: any) => {
        userStore.saveCountryImpersonationToLocalStorage(country);
        dispatch(impersonateCountrySuccess(country));
    };
}

export function unImpersonateCountry() {
    return (dispatch: any) => {
        userStore.removeCountryImpersonationFromLocalStorage();
        dispatch(unImpersonateCountrySuccess());
    };
}

export function logout() {
    return async (dispatch: any) => {
        const storedUser = userStore.fetchUserFromLocalStorage();
        dispatch(unImpersonateCountry());
        dispatch(logoutSuccess());

        let userManager = getUserManager();

        await userManager.signoutRedirect({
            id_token_hint: storedUser.id_token
        });
    };
}
